import CatalogoTratamientoABM from "./CatalogoTratamientoABM";
export default function AddEvolucionesClinicoTerapeuticas() {
  return <CatalogoTratamientoABM endpoint="/evoluciones-clinico-terapeuticas" idField="IdEvolucionClinicoTerapeutica" titulo="Agregar evolución clínico-terapéutica del tratamiento" nombreCampo="Evolución clínico-terapéutica" />;
}
